<div class="container-fluid">
  <div class="row">
    <div
      class="col-sm-12 d-flex justify-content-center align-items-center flex-column py-3"
    >
      <h2 mat-dialog-title class="font-bold mb-5">
        {{ 'Choose receipt' | translate }}
      </h2>
      <mat-dialog-content class="col-sm-12 w-100">
        <mat-card-content
          *ngIf="receipts.length && !loading; else noDocs"
          class="col-sm-12 w-100"
        >
          <div class="overflow-auto col-sm-12 w-100">
            <table
              mat-table
              [dataSource]="dataSource"
              class="full-wid sticky-header"
            >
              <ng-container matColumnDef="image">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'File preview' | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let element; let i = index"
                  style="padding: 10px"
                >
                  <img
                    class="file cursor-pointer"
                    src="{{ element.filePathThumbnail }}"
                    (click)="showImage(element.filePathThumbnail)"
                    alt=""
                  />
                </td>
              </ng-container>

              <ng-container matColumnDef="choose">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'Choose' | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let row; let i = index"
                  style="padding: 10px"
                >
                  <mat-checkbox
                    (change)="selectRow($event, row)"
                    [checked]="selectedRow == row"
                    color="primary"
                  >
                  </mat-checkbox>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="columns" sticky></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: columns"
                [ngClass]="{ selected_row: selectedRow == row }"
              ></tr>
            </table>
            <ng-container *ngIf="receipts.length == 0">
              <h4 class="pad-t-md">{{ 'No files found' | translate }}</h4>
            </ng-container>
          </div>
        </mat-card-content>
      </mat-dialog-content>
      <ng-template #noDocs>
        <div
          class="d-flex col-sm-12 justify-content-center align-items-center"
          *ngIf="!loading"
        >
          <div class="col-sm-12">
            {{ 'There is no files' | translate }}
          </div>
        </div>
      </ng-template>

      <mat-dialog-actions>
        <button mat-raised-button (click)="dialogRef.close()" color="warn">
          {{ 'CLOSE' | translate }}
        </button>
        <button
          *ngIf="receipts?.length"
          mat-raised-button
          (click)="choose()"
          [disabled]="!selectedRow"
          color="primary"
        >
          {{ 'Choose' | translate }}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
